const FORM_DATA_INITIAL = {
  name: {
    name: 'name',
    label: 'Nome',
    value: '',
  },
  pomodoro: {
    name: 'pomodoro',
    label: 'Pomodoro',
    type: 'number',
    value: '',
  },
  shortBreak: {
    name: 'shortBreak',
    label: 'Intervalo Curto',
    type: 'number',
    value: '',
  },
  longBreak: {
    name: 'longBreak',
    label: 'Intervalo Longo',
    type: 'number',
    value: '',
  },
}

export { FORM_DATA_INITIAL }
